import { Base } from "ui/Scripts/source/framework/base";
import { IListItems, ListItems } from "ui/Scripts/source/framework/listItems";
import { FileFilterListItem, IFileFilterListItem } from "./fileFilterListItem";

export interface IFileFilterListItems extends IListItems<IFileFilterListItem> {}

export class FileFilterListItems extends ListItems<FileFilterListItem> implements IFileFilterListItems {
    constructor();
    constructor(obj: IFileFilterListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, FileFilterListItem);
    }
}